<template>
  <div id="outsideContainer" class="border">
    <div class="card-wrapper">
      <el-button
        class="mt-4"
        style="width: 60%"
        :type="butType"
        @click="handleRecordingBtnClick"
        >{{ isRecording ? '正在录音中...请说话...' : '录音已停止' }}</el-button
      >
    </div>

    <div>
      <audio ref="vocaudio"></audio>
    </div>
    <canvas id="waveform" width="600" height="100"></canvas>
  </div>
</template>

<script>
export default {
  name: 'SpeakingRecordingCard',
  components: {},
  props: [],

  data () {
    return {
      rec: null,
      audioChunks: [],
      isRecording: false,
      butType: '',
      isRecordingCardInitialized: false
    }
  },

  watch: {},

  beforeMount: function () {},

  mounted: function () {
    this.initializeAudioRecording()
  },

  methods: {
    handleRecordingBtnClick: function () {
      // if (!this.isRecordingCardInitialized) {
      //   this.initializeAudioRecording();
      //   this.isRecordingCardInitialized = true;
      // }
      this.handleSpeechRecognition()

      this.isRecording = !this.isRecording
      //把isRecording的值传出去，一遍父组件能知道当前播放的状态
      this.$emit('on-recording-btn-click', this.isRecording)
      this.butType = this.isRecording ? 'danger' : ''
      if (this.isRecording) {
        this.handleStartRecording()
      } else {
        this.handleStopRecording()
      }
    },

    //这是浏览器内置的TTS语音识别，不过只能识别一小段就会自动停，不太好用
    handleSpeechRecognition: function () {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition
      const recognition = new SpeechRecognition()
      recognition.lang = 'en-US'
      recognition.interimResults = false
      recognition.continuous = true // Set to true for continuous recognition

      // Flag to track if recognition should continue
      let isRecognitionActive = true
      let finalResult = ''

      recognition.onstart = () => {
        console.log('Speech recognition started. Ready to receive audio.')
      }

      recognition.onresult = event => {
        const text = event.results[0][0].transcript
        finalResult += text + ' '
        console.log('Result received: ' + finalResult)
      }

      recognition.onend = () => {
        console.log('Speech recognition ended.')
        if (isRecognitionActive) {
          // Restart recognition if the flag is active
          recognition.start()
        }
      }

      recognition.onerror = event => {
        console.error('Speech recognition error:', event.error)
        if (
          event.error === 'not-allowed' ||
          event.error === 'service-not-allowed'
        ) {
          isRecognitionActive = false // Stop restarting if permission is denied
        }
      }

      // Start recognition
      recognition.start()

      // Stop recognition after 1 minute
      setTimeout(() => {
        isRecognitionActive = false
        recognition.stop()
        console.log('Stopped speech recognition after 1 minute.')
      }, 30000)
    },

    handleStartRecording: function () {
      // if (this.isRecording) {
      //   this.initializeAudioRecording();
      // }
      this.audioChunks = []
      if (this.rec) {
        this.rec.start()
      }
      //当录音开始的时候，使其允许手动点击结束录音
      //this.disabled = false;
      //this.getHuaweiCloudToken();
      this.$emit('on-recording-start')
    },

    handleStopRecording: function () {
      if (this.rec) this.rec.stop()
      //当录音结束，或者手动点击录音结束的时候，不能再次手动点击开启录音
      //this.disabled = true;
      this.$emit('on-recording-end')
    },

    initializeAudioRecording: function () {
      let _this = this
      const constraints = {
        audio: {
          sampleRate: 16000,
          channelCount: 1
        }
      }
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        _this.handleRecording(stream)
      })
      // function handlerFunction(stream) {
      //   console.log('getting stream~')
      //   _this.rec = new MediaRecorder(stream);
      //   _this.rec.ondataavailable = (e) => {
      //     _this.audioChunks.push(e.data);

      //     if (_this.rec.state == "inactive") {
      //       console.log('getting stream~')
      //       // /////////begin generating wave file
      //       // const header = new ArrayBuffer(44);
      //       // const view = new DataView(header);

      //       // //const audioData = _this.audioChunks.slice(44);
      //       // const audio16BitData = _this.convertTo16Bit(_this.audioChunks);

      //       // _this.writeString(view, 0, "RIFF");
      //       // view.setUint32(4, 36 + _this.audioChunks.length, true);
      //       // _this.writeString(view, 8, "WAVE");
      //       // _this.writeString(view, 12, "fmt ");
      //       // view.setUint32(16, 16, true);
      //       // view.setUint16(20, 1, true);
      //       // view.setUint16(22, 1, true);
      //       // view.setUint32(24, 16000, true);
      //       // view.setUint32(28, 16000 * 1 * 2, true);
      //       // view.setUint16(32, 1 * 2, true);
      //       // view.setUint16(34, 16, true);
      //       // _this.writeString(view, 36, "data");
      //       // view.setUint32(40, audio16BitData.length, true);
      //       // /////////end generating wave file

      //       // let blob = new Blob([header, ...audio16BitData], {
      //       //   type: "audio/wav",
      //       // });

      //       let blob = new Blob(_this.audioChunks, {
      //         type: "audio/wav",
      //       });
      //       // //let convertedBlob = _this.convertTo16Bit(blob);

      //       // let url = URL.createObjectURL(blob);
      //       // _this.$refs.vocaudio.src = url;

      //       // // Create a download link for the WAV file
      //       // let downloadLink = document.createElement("a");
      //       // downloadLink.href = url;
      //       // downloadLink.download = "recording.wav";
      //       // document.body.appendChild(downloadLink); // Append the link to the body
      //       // downloadLink.click();
      //       // document.body.removeChild(downloadLink);
      //       //sendData(blob)

      //       var reader = new FileReader();
      //       reader.readAsDataURL(blob);
      //       reader.onloadend = function () {
      //         var base64String = reader.result;
      //         let base64result = base64String.split("base64,")[1];
      //         _this.drawWaveImage(base64result);
      //         console.log(base64result);
      //         //_this.getElsaResponse(base64result);
      //         //_this.convertAudioToText(base64result);
      //       };
      //     }
      //   };
    },

    handleRecording: function (stream) {
      let _this = this
      console.log('getting stream~')
      _this.rec = new MediaRecorder(stream)
      _this.rec.ondataavailable = e => {
        _this.audioChunks.push(e.data)

        if (_this.rec.state == 'inactive') {
          console.log('getting stream~')
          // /////////begin generating wave file
          // const header = new ArrayBuffer(44);
          // const view = new DataView(header);

          // //const audioData = _this.audioChunks.slice(44);
          // const audio16BitData = _this.convertTo16Bit(_this.audioChunks);

          // /////////start generating wave file header
          // _this.writeString(view, 0, "RIFF");
          // view.setUint32(4, 36 + _this.audioChunks.length, true);
          // _this.writeString(view, 8, "WAVE");
          // _this.writeString(view, 12, "fmt ");
          // view.setUint32(16, 16, true);
          // view.setUint16(20, 1, true);
          // view.setUint16(22, 1, true);
          // view.setUint32(24, 16000, true);
          // view.setUint32(28, 16000 * 1 * 2, true);
          // view.setUint16(32, 1 * 2, true);
          // view.setUint16(34, 16, true);
          // _this.writeString(view, 36, "data");
          // view.setUint32(40, audio16BitData.length, true);
          // /////////end generating wave file header

          // let blob = new Blob([header, ...audio16BitData], {
          //   type: "audio/wav",
          // });

          let blob = new Blob(_this.audioChunks, {
            type: 'audio/wav'
          })
          // //let convertedBlob = _this.convertTo16Bit(blob);

          let url = URL.createObjectURL(blob)
          _this.$refs.vocaudio.src = url

          // Create a download link for the WAV file
          let downloadLink = document.createElement('a')
          downloadLink.href = url
          downloadLink.download = 'recording.wav'
          document.body.appendChild(downloadLink) // Append the link to the body
          downloadLink.click()
          document.body.removeChild(downloadLink)
          //sendData(blob)

          // var reader = new FileReader();
          // reader.readAsArrayBuffer(blob);
          // // reader.onloadend = function () {
          // //   var base64String = reader.result;
          // //   let base64result = base64String.split("base64,")[1];
          // //   _this.drawWaveImage(base64result);
          // //   console.log(base64result);
          // //   //_this.getElsaResponse(base64result);
          // //   //_this.convertAudioToText(base64result);
          // // };
          // reader.onload = function () {
          //   const buffer = reader.result;
          //   const header = new DataView(new ArrayBuffer(44));

          //   function writeString(view, offset, string) {
          //     for (let i = 0; i < string.length; i++) {
          //       view.setUint8(offset + i, string.charCodeAt(i));
          //     }
          //   }

          //   writeString(header, 0, "RIFF");
          //   header.setUint32(4, 36 + buffer.byteLength, true);
          //   writeString(header, 8, "WAVE");
          //   writeString(header, 12, "fmt ");
          //   header.setUint32(16, 16, true);
          //   header.setUint16(20, 1, true);
          //   header.setUint16(22, 1, true);
          //   header.setUint32(24, 16000, true);
          //   header.setUint32(28, 16000 * 2, true);
          //   header.setUint16(32, 2, true);
          //   header.setUint16(34, 16, true);
          //   writeString(header, 36, "data");
          //   header.setUint32(40, buffer.byteLength, true);

          //   const wavBuffer = new Uint8Array(44 + buffer.byteLength);
          //   wavBuffer.set(new Uint8Array(header.buffer), 0);
          //   wavBuffer.set(new Uint8Array(buffer), 44);

          //   const wavBlob = new Blob([wavBuffer], { type: "audio/wav" });
          //   const url = URL.createObjectURL(wavBlob);

          //   // 下载 WAV 文件
          //   const a = document.createElement("a");
          //   a.href = url;
          //   a.download = "recording.wav";
          //   a.click();
          //   window.URL.revokeObjectURL(url);
          // };
        }
      }
    },

    drawWaveImage: function (base64string) {
      // 解码 Base64 字符串为二进制数据
      var binaryData = atob(base64string)

      // 将二进制数据转换为一个 Uint8Array
      var bytes = new Uint8Array(binaryData.length)
      for (var i = 0; i < binaryData.length; i++) {
        bytes[i] = binaryData.charCodeAt(i)
      }

      // 创建 AudioContext
      var audioContext = new (window.AudioContext ||
        window.webkitAudioContext)()

      // 解码音频数据
      audioContext.decodeAudioData(bytes.buffer, function (decodedData) {
        // 获取波形数据
        var audioBuffer = decodedData.getChannelData(0) // 获取第一个声道的数据

        // 绘制波形图
        var canvas = document.getElementById('waveform')
        var ctx = canvas.getContext('2d')
        var width = canvas.width
        var height = canvas.height

        ctx.clearRect(0, 0, width, height)
        ctx.beginPath()
        for (var i = 0; i < audioBuffer.length; i++) {
          var x = i * (width / audioBuffer.length)
          var y = ((audioBuffer[i] + 1) * height) / 8
          if (i === 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }
        ctx.strokeStyle = '#000'
        ctx.stroke()
      })
    },

    // Set up the WAV file header
    writeString: function (view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i))
      }
    },

    convertTo16Bit: function (audioData) {
      if (!(audioData instanceof ArrayBuffer)) {
        // Convert audioData to ArrayBuffer
        const buffer = new ArrayBuffer(audioData.length)
        const view = new Uint8Array(buffer)
        for (let i = 0; i < audioData.length; i++) {
          view[i] = audioData[i]
        }
        audioData = buffer
      }

      const dataView = new DataView(audioData.slice(40))
      const newData = new Uint8Array(audioData.byteLength * 2) // Each sample will now be 16 bits (2 bytes)

      const maxSampleValue = Math.pow(2, dataView.byteLength * 8 - 1) - 1

      for (let i = 0; i < audioData.length; i += dataView.byteLength) {
        let sample = 0

        // Read the original sample value based on the size of each sample
        if (dataView.byteLength === 1) {
          sample = dataView.getInt8(i)
        } else if (dataView.byteLength === 2) {
          sample = dataView.getInt16(i, true) // Assuming little-endian format
        } else if (dataView.byteLength === 4) {
          sample = dataView.getInt32(i, true) // Assuming little-endian format
        }

        // Normalize the sample value to the range of 16-bit audio
        const normalizedSample = Math.round((sample / maxSampleValue) * 32767)

        // Convert the normalized sample to 16-bit format
        newData[i * 2] = normalizedSample & 0xff // Lower byte
        newData[i * 2 + 1] = (normalizedSample >> 8) & 0xff // Upper byte
      }

      return newData
    },

    getElsaResponse: function (base64Str) {
      this.$store
        .dispatch('Elsa/getElsaResponse', {
          api_plan: 'premium',
          return_json: true,
          audio_data: base64Str
        })
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error.toString())
        })
    }
  },

  beforeUnmount: function () {}
}
</script>
<style scoped></style>
